import React from 'react';
import Icon from '../icons';
import { URLS } from '../../_config';
import MenuLink from './_components/menuLink';
import noImg from '../../images/no-image.jpg';
import { useUserApi } from '../../store/api/hooks/userApiHook';
import toast from 'react-hot-toast';


const LeftPanel: React.FC = () => {

    const uaerAPI: any = useUserApi();

    const logout = () => {
        uaerAPI.logout({}, (response: any) => {
            console.log('response =>', response);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
        });
    }

    return (
        <div className="left-panel bg-primary text-white w-[16.25rem] flex-shrink-0 h-screen flex flex-col">
            <div className="flex justify-between py-4 px-3 border-b-[.03rem] border-[#406A42] h-[3.75rem]">
                <h2 className='uppercase'>arrowfoot.ai</h2>
                <div className='flex justify-center gap-2'>
                    <a href="" className='flex justify-center bg-white rounded-full p-[.15rem] w-[1.25rem] h-[1.25rem]'><Icon name='notification' size={1.05} className='text-primary' /></a>
                    <a href="" className='flex w-[1.25rem] h-[1.25rem] rounded-full overflow-hidden bg-white relative'> <span className='w-[0.313rem] h-[0.313rem] bg-[#F46A6A] rounded-full absolute right-0'></span> <img src={noImg} alt="" /> </a>
                </div>
            </div>
            <div className="overflow-y-auto flex-grow flex flex-col justify-between">
                <ul className="font-normal">

                    <MenuLink to={URLS.RM_OVERVIEW} label='R&M Overview' icon={<Icon name='meter' size={1.25} />} disabled={true} />
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>
                    <MenuLink to={URLS.FACILITIES} label='Facilities' icon={<Icon name='location' size={1.25} />} />
                    <MenuLink to={URLS.ASSETS} label='Assets' icon={<Icon name='assets' size={1.25} />} />
                    <MenuLink to={URLS.WARRANTIES} label='Warranties' icon={<Icon name='warranties' size={1.25} />} disabled={true}/>
                    <MenuLink to={URLS.LEASE_ASSETS} label='Lease Assets' icon={<Icon name='lease' size={1.25} />} disabled={true} />
                    <MenuLink to={URLS.DEPRECIATION} label='Depreciation' icon={<Icon name='depreciation' size={1.10} />} disabled={true}/>
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>
                    <MenuLink to={URLS.MAINTENANCE_CALENDER} label='Maintenance Calender' icon={<Icon name='calendar' size={1.25} />} disabled={true} />
                    <MenuLink to={URLS.WORK_ORDERS} label='Work Orders' icon={<Icon name='workorders' size={1.25} />} disabled={true} />
                    <MenuLink to={URLS.CHECKLISTS} label='Checklists' icon={<Icon name='checklist' size={1.25} />} disabled={true} />
                    <div className='my-[5px] h-0 w-full border-b border-[#406A42]'></div>

                    <li className="dropdown dropdown-bottom w-full">
                        <div tabIndex={0} role="button" className="w-full flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group">
                            <div className='flex justify-center items-center w-[1.675rem]'>
                                <Icon name='inventory' size={1.25} />
                            </div>
                           <div className='flex justify-between items-center w-full'>
                             <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Inventory</span>
                             <Icon name='arrowdown' className='pr-3' size={1.25} />
                           </div> 
                        </div>
                        <ul tabIndex={0} className="dropdown-content z-10 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm">
                            <MenuLink to={URLS.INVENTORY.SPEAR_PARTS.LIST} label='Spare Parts' icon={null} />
                            <MenuLink to={URLS.INVENTORY.RECEIVE_STOCK} label='Receive Stock' icon={null} disabled={true}/>
                            <MenuLink to={URLS.INVENTORY.STOCK_PICKING} label='Stock Picking' icon={null} disabled={true}/>
                            <MenuLink to={URLS.INVENTORY.STOCK_ADJUSTMENT} label='Stock Adjustment' icon={null} />
                            <MenuLink to={URLS.INVENTORY.CYCLE_COUNT} label='Cycle Count' icon={null} />
                        </ul>
                    </li>

                    <li className="dropdown dropdown-bottom w-full">
                        <div tabIndex={1} role="button" className="w-full flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group">
                            <div className='flex justify-center items-center w-[1.675rem]'>
                                <Icon name='purchase' size={1.25} />
                            </div>
                            <div className='flex justify-between items-center w-full'>
                             <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Purchasing</span>
                             <Icon name='arrowdown' className='pr-3' size={1.25} />
                            </div>
                        </div>
                        <ul tabIndex={1} className="dropdown-content z-10 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm">
                            <MenuLink to={URLS.PURCHASING.REQUEST} label='Purchase Request' icon={null} disabled={true}/>
                            <MenuLink to={URLS.PURCHASING.ORDER} label='Purchase Order' icon={null} disabled={true}/>
                            <MenuLink to={URLS.PURCHASING.STOCK} label='Purchase Stock' icon={null} disabled={true}/>

                        </ul>
                    </li>
                    
                    <MenuLink to={URLS.VENDORS} label='Vendors' icon={<Icon name='vendors' size={1.25} />} disabled={true}/>





                </ul>
                <ul className="font-light">

                    <MenuLink to={URLS.USERS} label='Users' icon={<Icon name='users' size={1.25} />} disabled={true} />
                    <MenuLink to={URLS.REPORTS} label='Reports' icon={<Icon name='reports' size={1.25} />} disabled={true}/>
                    <MenuLink to={URLS.SETTINGS} label='Settings' icon={<Icon name='settings' size={1.20} />} disabled={true} />
                    <MenuLink to={URLS.ACCOUNT} label='Account' icon={<Icon name='allusers' size={1.25} />} disabled={true} />
                    <li>
                        <span onClick={logout} className="flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] transition-all hover:bg-[#2020324D] group">
                            <div className='flex justify-center items-center w-[1.675rem]'>
                                <Icon name='logout' size={1.25} className='text-white' />
                            </div>
                            <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">Logout</span>
                        </span>
                    </li>

                </ul>
            </div>
            
        </div>
    );
};

export default LeftPanel;